import React, { Component } from 'react';

import Lottie from 'lottie-react';
import k_prime from '../../../../images/anims/k_prime.json';

function RechargeWalletKuposPayPrime(props) {
  return (
    <div id="sub-body-my-account" className="my-account-recharge-wallet-kupospay-recharge ">
      <div className="kupos-prime-container ">
        <div className="white-triangle kupos-prime"></div>
        <div className="my-account-title center-text">
          <div className="sub-section-account-general-title font13">
            kupos<span className="bold-text">prime</span>
          </div>
          <div className="sub-section-description-description font11">
            <span>{props.t('PROFILE.PREMIUM_BENIFITS')}</span>
          </div>
        </div>
        <Lottie animationData={k_prime} loop={true} style={{ height: '240px', marginTop: '5vh' }} />

        <div className="coming-soon-label-container">
          <span className="coming-soon-label bold-text">{props.t('TRANSLATIONS.COMING_SOON')}</span>
        </div>
      </div>
    </div>
  );
}

export default RechargeWalletKuposPayPrime;



// WEBPACK FOOTER //
// ./src/features/themes/my-account/RechargeWalletKupospayPrime/RechargeWalletKupospayPrime.js